export const endpoints = {
  // Admin Auth
  ADMIN_LOGIN: "/auth/admin/login",
  ADMIN_LOGOUT: "/auth/admin/logout",
  ADMIN_FORGOT_PASSWORD: "/auth/admin/password/reset",
  ADMIN_VALIDATE_RESET_TOKEN: (token) => `/auth/admin/${token}/reset`,
  ADMIN_RESET_PASSWORD: (token) => `/auth/admin/${token}/reset`,

  // Admin Profile
  GET_ADMIN_PROFILE: "/admin/profile",
  UPDATE_ADMIN_PROFILE: "/admin/profile/update",
  CHANGE_ADMIN_PASSWORD: "/admin/password/update",

  // Dashboard
  DASHBOARD_STATS: "/admin/dashboard/stats",

  // User Management
  USER_LIST: "/admin/users/list",
  USER_DETAIL: (id) => `/admin/users/${id}/detail`,
  USER_TOGGLE_STATUS: (id) => `/admin/users/${id}/status`,
  USER_DELETE: (id) => `/admin/users/${id}/delete`,

  // Contact Inquiries
  INQUIRY_LIST: "/admin/inquiries/list",
  INQUIRY_UPDATE_STATUS: (id) => `/admin/inquiries/${id}/status`,
  INQUIRY_REPLY: (id) => `/admin/inquiries/${id}/reply`,

  // FAQs
  FAQ_LIST: "/admin/faqs/list",
  FAQ_CREATE: "/admin/faqs/create",
  FAQ_UPDATE: (id) => `/admin/faqs/${id}/update`,
  FAQ_DELETE: (id) => `/admin/faqs/${id}/delete`,

  // CMS
  CMS_LIST: "/admin/cms/list",
  CMS_GET: (id) => `/admin/cms/${id}`,
  CMS_UPDATE: "/admin/cms/update",

  // Features
  FEATURE_LIST: "/admin/features/list",
  FEATURE_CREATE: "/admin/features/create",
  FEATURE_UPDATE: (id) => `/admin/features/${id}/update`,
  FEATURE_DELETE: (id) => `/admin/features/${id}/delete`,

  // News Articles
  NEWS_LIST: "/admin/news/list",
  NEWS_CREATE: "/admin/news/create",
  NEWS_UPDATE: (id) => `/admin/news/${id}/update`,
  NEWS_DELETE: (id) => `/admin/news/${id}/delete`,

  // User Inquiries
  USER_SUBMIT_INQUIRY: "/user/inquiries",
  USER_INQUIRY_LIST: "/user/inquiries",
};
